import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { ConfigurationSearchStoreEffects } from './effects';
import * as fromConfigurationSearchStore from './reducer';

export function provideConfigurationSearchStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(fromConfigurationSearchStore.configurationSearchStoreFeatureKey, fromConfigurationSearchStore.reducer),
    provideEffects(ConfigurationSearchStoreEffects),
  ]);
}
